import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class LoginRedirectService implements CanActivate {

  constructor(private router: Router) { }
  canActivate(): boolean {
    if (localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')) {
      this.router.navigateByUrl('/inicio');
      return false;
    }else{
      return true;
    }
  }
}
